import lodashFind from 'lodash/find';

import ThemeColor from '../../Theme/colors';

import { CATEGORIES } from './constants';

const colors = [
  {
    category: CATEGORIES.BASIC,
    value: ThemeColor.lightGray,
  },
  {
    category: CATEGORIES.PRIMARY,
    value: ThemeColor.violet,
  },
  {
    category: CATEGORIES.SUCCESS,
    value: ThemeColor.green,
  },
  {
    category: CATEGORIES.INFO,
    value: ThemeColor.blue,
  },
  {
    category: CATEGORIES.WARNING,
    value: ThemeColor.yellow,
  },
  {
    category: CATEGORIES.DANGER,
    value: ThemeColor.red,
  },
];

export default function getBorderColor(category) {
  const selectedColor = lodashFind(colors, { category });
  return selectedColor.value || ThemeColor.black;
}
